import React from 'react'

import {
  BenefitDetailsResponse,
  BenefitProductClassResponse,
  RenewalBenefitDesignWizardResponse,
  getBenefitDetails,
} from 'core'

import { Button, Col, Row } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import ProductClassDetailsV3 from './ProductClassDetailsV3'

type ProductClassListV2Props = {
  productClasses: BenefitProductClassResponse[]
  planPeriodId: string
  showIcon?: boolean
  showBenefitDates?: boolean
  isRenewal?: boolean
  productClassesInfo?: RenewalBenefitDesignWizardResponse
  onEdit?: (productClass: BenefitProductClassResponse) => void
  onArchive?: (productClass: BenefitProductClassResponse) => void
  onDelete?: (productClass: BenefitProductClassResponse) => void
  onRenewalDelete?: (productClass: BenefitProductClassResponse) => void
  onDesignClass?: (productClass: BenefitProductClassResponse) => void
  onRenewalEdit?: (productClass: BenefitProductClassResponse) => void
  onSubmit?: () => Promise<void>
  onNewClass?: () => void
}

const ProductClassListV2 = ({
  productClasses,
  planPeriodId,
  showIcon,
  showBenefitDates,
  isRenewal = false,
  productClassesInfo,
  onEdit,
  onArchive,
  onDelete,
  onRenewalDelete,
  onDesignClass,
  onRenewalEdit,
  onSubmit,
  onNewClass,
}: ProductClassListV2Props) => {
  const { data: benefitDetails } = useQueryRequestV2<BenefitDetailsResponse>({
    queryFn: () => getBenefitDetails(planPeriodId),
  })

  const getProductClassesInfo = (productClassId: string) => {
    return productClassesInfo?.productClassesInfo.find((x) => x.id === productClassId) || null
  }

  return (
    <>
      <Row className="pt-16">
        <Col span={17} className={'benefit_design_page_header_v2'}>
          <Row align={'middle'} justify={'space-between'}>
            <Col span={18}>
              <h5 className={'mt-0'}>Your classes</h5>
            </Col>
            <Col span={6} className="text-right">
              <Button type="default" onClick={onNewClass}>
                <span>
                  <i className="fa fa-plus pr-8" aria-hidden="true"></i>
                  Add new class
                </span>
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mt-8 mb-16">
        <Col sm={24} lg={17} className={'benefit_design_page_header_v2'}>
          {productClasses.map((item, index) => (
            <Col span={24} key={index}>
              <ProductClassDetailsV3
                key={item.id}
                item={item}
                collapseKey={index}
                benefitStartDate={benefitDetails?.startDate}
                benefitEndDate={benefitDetails?.endDate}
                productClassesInfo={getProductClassesInfo(item.id)}
                colSpan={24}
                showIcon={showIcon}
                showBenefitDates={showBenefitDates}
                planPeriodId={planPeriodId}
                onEdit={onEdit}
                onDelete={onDelete}
                onArchive={onArchive}
                onDesignClass={onDesignClass}
                isRenewal={isRenewal}
                onRenewalEdit={onRenewalEdit}
                onSubmit={onSubmit}
                onRenewalDelete={onRenewalDelete}
              />
            </Col>
          ))}
        </Col>
      </Row>
    </>
  )
}

export default ProductClassListV2
